import { GameSettings, initGameSettingsState } from 'common/stores/GameSettings';
import { matchProject, isLandscape, isMobile } from 'common/helpers/GameHelper';
import { RotateModalComponent } from 'components/modal/RotateModal';
import { useUserSession } from 'common/stores/UserSessionStore';
import HttpService from 'common/services/HttpService';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';


export function GameSettingsComponent({ children }) {
    const { getLeapAccount } = useUserSession();
    const [state, setState] = useState(initGameSettingsState);
    const [rotateScreen, setRotateScreen] = useState(isLandscape());
    const { projectId } = useParams() || {};


    useEffect(() => {
        fetchGameSettings();

        if(isMobile()){
            if(screen.orientation) {
                screen.orientation.addEventListener("change", function(e) {
                    if(e.target.type.includes("landscape")) {
                        setRotateScreen(true);
                    }
                    else {
                        setRotateScreen(false);
                    }
                }, false);
            } else {
                window.addEventListener("resize", function(e) {
                    if(isLandscape()) setRotateScreen(true);
                    else setRotateScreen(false);
                }, false);
            }

        }
    }, []);

    async function fetchGameSettings() {
        return;
        const { uid } = getLeapAccount();
        const { gameId } = matchProject(projectId);

        try {
            const gameSettings = await HttpService.fetchUserSettings({ gameId, userId: uid })

            return setState(gameSettings);
        } catch (error) {
            console.log(error);
        };
    };

    async function setGameSettings(body = state) {
        const { uid } = getLeapAccount();
        const { gameId } = matchProject(projectId);

        try {
            return setState(body); //TODO REMOVE THIS

            const gameSettings = await HttpService.setUserSettings(gameId, {
                ...body,
                userId: uid
            })

            return setState(gameSettings);
        } catch (error) {
            console.log(error);
        };
    };

    return (
        <GameSettings.Provider value={{
            gameSettings: state,
            fetchGameSettings,
            setGameSettings
        }}>
            {(rotateScreen) ? <RotateModalComponent /> : null}
            {children}
        </GameSettings.Provider>
    );
};